@if (directLoadCurve.isLoading()) {
  <ui-skeleton class="h-50 w-full rounded-lg" />
} @else if (directLoadCurve.error()) {
  <app-error-page
    [error]="directLoadCurve.error()"
    (clickBack)="router.navigate(['/organizations', organizationId(), 'energy-interfaces'])"
    class="block"
    style="height: calc(100vh - 20rem)"
  />
} @else {
  @if (directLoadCurve.value(); as loadCurve) {
    <div class="flex flex-col gap-5">
      <ui-input-label>
        {{ 'cockpit.energyInterfaces.details.loadCurve.loadCurveDataLabel' | transloco }}
        <ui-dropzone slot="input" (dropFiles)="onFileDrop(loadCurve.id, $event)" accept="text/csv">
          <ng-container slot="title">
            {{ 'cockpit.energyInterfaces.details.loadCurve.dropzone.titlePrefix' | transloco }}
            <label
              class="text-primary dark:text-primary-darkmode hover:underline cursor-pointer"
              for="upload-load-curve-input"
            >
              {{ 'cockpit.energyInterfaces.details.loadCurve.dropzone.titleLink' | transloco }}
            </label>
            {{ 'cockpit.energyInterfaces.details.loadCurve.dropzone.titleSuffix' | transloco }}
            <input
              type="file"
              class="hidden"
              id="upload-load-curve-input"
              multiple
              (change)="onFileChange(loadCurve.id, $event)"
              accept="text/csv"
            />
          </ng-container>
          <ng-container slot="dragover-title">
            {{ 'cockpit.energyInterfaces.details.loadCurve.dropzone.dragoverTitle' | transloco }}
          </ng-container>
          <ng-container slot="subtitle">
            <div class="flex flex-col gap-1">
              <span>
                {{ 'cockpit.energyInterfaces.details.loadCurve.dropzone.subtitle' | transloco }}
              </span>
              <a
                href="/example-load-curve.csv"
                download
                class="text-primary dark:text-primary-darkmode hover:underline"
              >
                {{
                  'cockpit.energyInterfaces.details.loadCurve.dropzone.downloadExample' | transloco
                }}
              </a>
            </div>
          </ng-container>
          @for (state of files(); track state.id) {
            <ui-dropzone-file
              [error]="state.error"
              [titleText]="state.file.name"
              subtitle="{{ (state.file.size / 1024 / 100) * state.progress | number: '1.2-2' }}/{{
                state.file.size / 1024 | number: '1.2-2'
              }} KB - {{ state.messageKey | transloco: state.messageParams }}"
              [progress]="state.progress"
              [transitionDuration]="validatedChunkSize()"
              (clickRetry)="onClickRetry(loadCurve.id, state)"
              (clickRemove)="onClickRemove(state.id)"
            />
          }
        </ui-dropzone>
      </ui-input-label>
      <ui-input-label>
        {{ 'cockpit.energyInterfaces.details.loadCurve.advancedOptionsLabel' | transloco }}
        <ui-toggle-label slot="input">
          {{ 'cockpit.energyInterfaces.details.loadCurve.showAdvancedOptionsLabel' | transloco }}
          <ui-toggle [formField]="form.showAdvancedOptions" />
        </ui-toggle-label>
      </ui-input-label>
      @if (form.showAdvancedOptions().value()) {
        <ui-input-label>
          {{ 'cockpit.energyInterfaces.details.loadCurve.chunkSizeLabel' | transloco }}
          <ui-input-simple type="text" inputmode="numeric" [formField]="form.chunkSize" />
          <app-field-errors slot="bottom" [fieldState]="form.chunkSize()" />
        </ui-input-label>
      }
    </div>
  }
}
